function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Transaction = require('../../../lib/saito/transaction')["default"];

// A submitted amount may differ from the cached quote by this fraction.
// One basis point of floating-point noise is inside this band; a different rate is not.
var QUOTE_TOLERANCE = 0.01;
function saitoPublicKey(app, value) {
  var _app$crypto;
  var key = String(value || '').trim();
  if (!key || typeof (app === null || app === void 0 || (_app$crypto = app.crypto) === null || _app$crypto === void 0 ? void 0 : _app$crypto.isPublicKey) !== 'function' || !app.crypto.isPublicKey(key)) {
    return '';
  }
  return key;
}
function storePurchaseMessage(app, raw) {
  if (!raw) {
    return null;
  }
  try {
    var tx = new Transaction();
    if (typeof tx.deserialize_from_web === 'function') {
      tx.deserialize_from_web(app, raw);
    }
    var message = typeof tx.returnMessage === 'function' ? tx.returnMessage() : null;
    if ((message === null || message === void 0 ? void 0 : message.module) === 'Store' && (message === null || message === void 0 ? void 0 : message.request) === 'purchase-asset') {
      return message;
    }
  } catch (err) {
    return null;
  }
  return null;
}
function storePurchaseRecipient(app, message) {
  return saitoPublicKey(app, message === null || message === void 0 ? void 0 : message.refund) || saitoPublicKey(app, message === null || message === void 0 ? void 0 : message.buyer);
}
var BuySaitoService = /*#__PURE__*/function () {
  function BuySaitoService(app, mod) {
    _classCallCheck(this, BuySaitoService);
    this.app = app;
    this.mod = mod;
    this.quote_tolerance = QUOTE_TOLERANCE;
  }

  /**
   * Start a normal SAITO purchase or a Store purchase. Distinguishes the two
   * from the request payload, computes the quote, then asks Transfers for a
   * purpose-aware deposit-address reservation.
   */
  return _createClass(BuySaitoService, [{
    key: "startPurchase",
    value: function () {
      var _startPurchase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(requesterPublickey) {
        var _this = this;
        var request,
          ticker,
          crypto,
          erc,
          ercPrice,
          usdPrice,
          priceFresh,
          saitoPrice,
          submittedIssue,
          submittedDeposit,
          hasIssue,
          hasDeposit,
          depositForIssue,
          issueForDeposit,
          closeEnough,
          issueAmount,
          expectedDeposit,
          purchase,
          purpose,
          inboundConfirmationsRequired,
          recipient,
          reserved,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              request = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              ticker = request.ticker;
              crypto = this.mod.crypto_mods.find(function (item) {
                return item.ticker === ticker;
              });
              if (crypto) {
                _context.n = 1;
                break;
              }
              throw new Error("Unsupported payment ticker: ".concat(ticker));
            case 1:
              if (!(!crypto.last_update || Date.now() - crypto.last_update > 300000)) {
                _context.n = 2;
                break;
              }
              _context.n = 2;
              return crypto.returnMixinNetworkInfo();
            case 2:
              erc = this.mod.crypto_mods.find(function (item) {
                return item.ticker === 'ERC-SAITO';
              });
              if (!(erc && (!erc.last_update || Date.now() - erc.last_update > 300000))) {
                _context.n = 3;
                break;
              }
              _context.n = 3;
              return erc.returnMixinNetworkInfo();
            case 3:
              if (!(request.price_usd != null || request.usd_price != null || request.saito_price != null || request.rate != null || request.exchange_rate != null)) {
                _context.n = 4;
                break;
              }
              throw new Error('BuySaito: the exchange rate is set by the server');
            case 4:
              ercPrice = Number(erc === null || erc === void 0 ? void 0 : erc.price_usd);
              usdPrice = Number(crypto.price_usd);
              priceFresh = function priceFresh(item) {
                return (item === null || item === void 0 ? void 0 : item.last_update) && Date.now() - item.last_update <= 300000;
              };
              if (!(!priceFresh(crypto) || !priceFresh(erc) || !Number.isFinite(usdPrice) || usdPrice <= 0 || !Number.isFinite(ercPrice) || ercPrice <= 0)) {
                _context.n = 5;
                break;
              }
              throw new Error("No price is available for ".concat(ticker));
            case 5:
              // The same spread and six-decimal deposit rounding used when the client quoted.
              saitoPrice = Math.max(0.001, 1.1 * ercPrice);
              submittedIssue = Number(request.issue_amount);
              submittedDeposit = Number(request.expected_deposit);
              hasIssue = Number.isFinite(submittedIssue) && submittedIssue > 0;
              hasDeposit = Number.isFinite(submittedDeposit) && submittedDeposit > 0;
              if (!(!hasIssue && !hasDeposit)) {
                _context.n = 6;
                break;
              }
              throw new Error('BuySaito: invalid payment amount');
            case 6:
              depositForIssue = function depositForIssue(issue) {
                return Math.ceil(issue * saitoPrice / usdPrice * 1000000) / 1000000;
              };
              issueForDeposit = function issueForDeposit(deposit) {
                return Math.floor(deposit * usdPrice / saitoPrice);
              };
              closeEnough = function closeEnough(submitted, expected) {
                return Number.isFinite(submitted) && Number.isFinite(expected) && expected > 0 && Math.abs(submitted - expected) <= expected * _this.quote_tolerance;
              };
              issueAmount = 0;
              expectedDeposit = 0;
              if (!(hasIssue && closeEnough(hasDeposit ? submittedDeposit : depositForIssue(submittedIssue), depositForIssue(submittedIssue)))) {
                _context.n = 7;
                break;
              }
              issueAmount = submittedIssue;
              expectedDeposit = depositForIssue(submittedIssue);
              _context.n = 9;
              break;
            case 7:
              if (!(hasDeposit && closeEnough(hasIssue ? submittedIssue : issueForDeposit(submittedDeposit), issueForDeposit(submittedDeposit)))) {
                _context.n = 8;
                break;
              }
              expectedDeposit = submittedDeposit;
              issueAmount = issueForDeposit(submittedDeposit);
              _context.n = 9;
              break;
            case 8:
              throw new Error('BuySaito: the order does not match the current exchange rate');
            case 9:
              if (!(!Number.isFinite(issueAmount) || issueAmount <= 0 || !Number.isFinite(expectedDeposit) || expectedDeposit <= 0)) {
                _context.n = 10;
                break;
              }
              throw new Error('BuySaito: invalid payment amount');
            case 10:
              purchase = storePurchaseMessage(this.app, request.tx);
              purpose = 'buysaito';
              inboundConfirmationsRequired = Number(crypto.confirmations || 0);
              if (!purchase) {
                _context.n = 12;
                break;
              }
              if (storePurchaseRecipient(this.app, purchase)) {
                _context.n = 11;
                break;
              }
              throw new Error('Store purchase refund recipient is missing');
            case 11:
              purpose = 'store-purchase';
              inboundConfirmationsRequired = 0;
            case 12:
              recipient = request.recipient_pubkey || request.recipient_publickey || requesterPublickey;
              _context.n = 13;
              return this.mod.transfers.reserveAddress(requesterPublickey, {
                purpose: purpose,
                ticker: ticker,
                recipient_publickey: recipient,
                inbound_amount: String(expectedDeposit),
                outbound_amount: String(issueAmount),
                inbound_confirmations_required: inboundConfirmationsRequired,
                payload: request.tx || '',
                request_id: request.request_id || '',
                outbound_address: recipient
              });
            case 13:
              reserved = _context.v;
              return _context.a(2, this.buildDepositReservationResponse(reserved));
          }
        }, _callee, this);
      }));
      function startPurchase(_x) {
        return _startPurchase.apply(this, arguments);
      }
      return startPurchase;
    }()
  }, {
    key: "releasePurchaseReservation",
    value: function () {
      var _releasePurchaseReservation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(requesterPublickey, ticker) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, this.mod.transfers.releaseAddress(requesterPublickey, ticker, 'buysaito'));
          }
        }, _callee2, this);
      }));
      function releasePurchaseReservation(_x2, _x3) {
        return _releasePurchaseReservation.apply(this, arguments);
      }
      return releasePurchaseReservation;
    }()
  }, {
    key: "buildDepositReservationResponse",
    value: function buildDepositReservationResponse(row) {
      var status = 'new';
      if (row.status === 'inbound_broadcast') {
        status = 'pending';
      } else if (row.status === 'inbound_confirmed') {
        status = 'confirmed';
      } else if (row.outbound_tx_sig && row.status !== 'outbound_confirmed') {
        status = 'issuing';
      }
      return {
        id: row.id,
        status: status,
        initiator_pubkey: row.requester_publickey,
        recipient_pubkey: row.recipient_publickey,
        issue_amount: row.outbound_amount,
        ticker: row.inbound_ticker || row.ticker,
        address: row.inbound_address || row.address,
        mixin_id: row.inbound_mixin_user_id || row.mixin_id,
        expected_deposit: row.inbound_amount,
        reserved_until: row.reserved_until != null ? Number(row.reserved_until) : Number(row.created_at) + this.mod.transfers.reservation_ms
      };
    }
  }]);
}();
module.exports = BuySaitoService;
module.exports.QUOTE_TOLERANCE = QUOTE_TOLERANCE;
module.exports.storePurchaseMessage = storePurchaseMessage;
module.exports.storePurchaseRecipient = storePurchaseRecipient;